import Swiper from 'swiper';
import { Navigation } from 'swiper';
import { getDisplayMode } from '../common/libs.js';
const setSchedule = () => {
  const setSlider = (slider) => {
    if (!slider || slider.classList.contains('is-init')) return false;

    const slideLength = slider?.querySelectorAll(".swiper-slide").length;
    let windowWidth = slider?.clientWidth;
    let slideSize = 0;
    let slideSpace = 0;
    if (getDisplayMode() == 1) {
      slideSize = 250;
      slideSpace = 30;
    } else {
      slideSize = 135;
      slideSpace = 20;
    }
    let viewSlideLength = Math.floor(windowWidth / (slideSize + slideSpace));

    if (slideLength > viewSlideLength) {
      var swiper = new Swiper(slider, {
        modules: [Navigation],
        speed: 500,
        loop: false,
        slidesPerView: 'auto',
        spaceBetween: slideSpace,
        navigation: {
          nextEl: slider.querySelector('.schedule-slider-button.next'),
          prevEl: slider.querySelector('.schedule-slider-button.prev'),
        },
      });
    } else {
      slider?.classList.add('slide-none');
    }

    slider.classList.add('is-init');
  }

  const setTabnav = (targetClass) => {
    const tabnavs = document.querySelectorAll(`.section-schedule ${targetClass}-nav`);
    if (!tabnavs || tabnavs.length == 0) return false;

    for (const tabnav of tabnavs) {
      const btns = tabnav?.querySelectorAll(`${targetClass}nav-btn`),
        tabcontent = tabnav?.closest(`${targetClass}`).querySelector(`${targetClass}-content`),
        contents = tabcontent?.querySelectorAll(`${targetClass}-box`);

      btns?.forEach(btn => {
        btn.addEventListener('click', function () {
          const id = this.dataset.id;

          btns.forEach(btn => {
            btn.classList.remove('is-active')
          })
          this.classList.add('is-active')

          contents.forEach(content => {
            content.classList.remove('is-active')
          })
          document.querySelector('#' + id).classList.add('is-active');

          const slider = document.querySelector('#' + id).querySelector('.schedule-slider');
          slider ? setSlider(slider) : '';
        })
      });
    }
  }

  setTabnav('.js-tab');
  setTabnav('.js-department-tab');

  setSlider(document.querySelector('.schedule-slider'));
}

export default setSchedule;